import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { DefaultSpinner } from '../_common/spinner/Spinner';
import GarageInactive from '../garage-inactive/GarageInactive';
import { GarageWrapper, Title, GarageCardContainer, GarageSpinnerWrapper } from './Garage.styles';
import Error from '../error/Error';
import { Experiments, AnalyticEvents, ReferenceTypes } from '../../constants';
import GarageCard from '../garage-card/GarageCard';
import { getOVPHeaderData, getOvpMfeFeed, setOvpReferenceType } from '../../store/OvpPageStore';
import { Analytics } from '../../services/analytics-service';
import { datadogRum } from '@datadog/browser-rum';

const Garage = (props: { landingPageState: any }) => {
  const addVehicleCookie = Cookies.get(Experiments.ADD_VEHICLE);
  const referenceType = ReferenceTypes.VEHICLE;

  setOvpReferenceType(referenceType);

  const { landingPageState } = props;
  const output: any = {
    prePurchaseVehicles: undefined,
    postPurchaseVehicles: undefined,
    postOrderVehicles: undefined,
    appraisals: undefined,
    isGarageDataFetched: false,
    apiResponseError: false,
  };

  const [ovpData, setOvpData] = useState<any>([]);
  const [ovpFeed, setOvpFeed] = useState([]);
  const [isOVPDataLoading, setIsOVPDataLoading] = useState(true);

  const getGarageCards = async () => {
    if (landingPageState?.garageDataError) {
      output.apiResponseError = true;
      Analytics.trackEvent(AnalyticEvents.garageErrorState);
      datadogRum.addAction(AnalyticEvents.garageErrorState);
      return;
    }
    if (landingPageState) {
      output.prePurchaseVehicles = landingPageState.prePurchaseVehicles;
      output.preOrderVehicles = landingPageState.preOrderVehicles;
      output.postPurchaseVehicles = landingPageState.postPurchaseVehicles;
      output.appraisals = landingPageState.appraisals;
      output.isGarageDataFetched = landingPageState.isGarageDataFetched;
    }
  };

  getGarageCards();

  const { prePurchaseVehicles, postPurchaseVehicles, preOrderVehicles, appraisals, apiResponseError } = output;

  const isLoading =
    prePurchaseVehicles === undefined &&
    preOrderVehicles === undefined &&
    postPurchaseVehicles === undefined &&
    appraisals === undefined;

  const vehicleId = prePurchaseVehicles?.length > 0 ? prePurchaseVehicles[0].vehicle?.id : '';

  const getOVPData = async () => {
    if (vehicleId === '') {
      return;
    }
    // TODO: Need a light weight endpoint to make this one car only status check
    const ovpHeaderResponse = await getOVPHeaderData(Number(vehicleId));
    const ovpMfeResponse = await getOvpMfeFeed(Number(vehicleId));

    if (ovpHeaderResponse.ovpDataError || ovpMfeResponse.ovpMfeDataError || ovpHeaderResponse.length === 0) {
      Analytics.trackEvent(AnalyticEvents.ovpErrorState, {
        page: 'garage',
        facadeOwned: !!ovpHeaderResponse.ovpDataError,
        facadeFeed: !!ovpMfeResponse.ovpMfeDataError,
      });
      datadogRum.addAction(AnalyticEvents.ovpErrorState, {
        page: 'garage',
        facadeOwned: !!ovpHeaderResponse.ovpDataError,
        facadeOwnedError: ovpHeaderResponse.ovpDataError,
        facadeFeed: !!ovpMfeResponse.ovpMfeDataError,
        facadeFeedError: ovpMfeResponse.ovpMfeDataError,
      });
      setIsOVPDataLoading(false);
      return;
    }

    setOvpData(ovpHeaderResponse);

    if (ovpMfeResponse.length > 0) {
      setOvpFeed(ovpMfeResponse);
    }

    setIsOVPDataLoading(false);
  };

  useEffect(() => {
    getOVPData();

    return () => {
      setOvpData([]);
      setOvpFeed([]);
    };
  }, []);

  // --------------------- UI fragments

  const ErrorPane = () => {
    return <Error screen="left" />;
  };

  const GaragePane = () => {
    return (
      <>
        <Title data-testid="my-cars-title">My Cars</Title>
        {isLoading ? (
          <GarageSpinnerWrapper>
            <DefaultSpinner />
          </GarageSpinnerWrapper>
        ) : (
          <>
            {landingPageState?.garageActiveState === false && <GarageInactive />}
            {/* Active State where a Purchase is in Progress and/ or a vehicle is already purchased */}
            <GarageCardContainer>
              {landingPageState?.garageActiveState === true && (
                <GarageCard
                  prePurchaseVehicles={prePurchaseVehicles}
                  preOrderVehicles={preOrderVehicles}
                  postPurchaseVehicles={postPurchaseVehicles}
                  appraisals={appraisals}
                  ovpData={ovpData[0]}
                  ovpFeed={ovpFeed}
                />
              )}
            </GarageCardContainer>
          </>
        )}
      </>
    );
  };

  const Page = () => {
    return (
      <GarageWrapper addVehicleExpValue={addVehicleCookie}>
        {apiResponseError ? <ErrorPane /> : <GaragePane />}
      </GarageWrapper>
    );
  };

  return <Page />;
};

export default Garage;
